@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

@selector-cell: 15px;

.error-or-warn-data-table {
  border: 1px solid @label-batch-status--border-color;
  font-size: 13px;
  margin-top: 10px;

  button {
    font-size: 13px;
  }

  &.two-columns {
    .header-cell,
    .body-cell {
      &:first-child {
        width: 20%;
        min-width: 20%;
        max-width: 20%;
      }

      &:last-child {
        width: 80%;
        min-width: 80%;
        max-width: 80%;
      }

      &.zero-state {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        justify-content: center;
      }
    }
  }

  &.four-columns {
    .header-cell,
    .body-cell {
      &:first-child {
        width: @selector-cell;
        min-width: @selector-cell;
        max-width: @selector-cell;
      }

      &:nth-child(2) {
        width: calc(18% ~'-' @selector-cell);
        min-width: calc(18% ~'-' @selector-cell);
        max-width: calc(18% ~'-' @selector-cell);
      }

      &:nth-child(3) {
        width: calc(64% ~'-' @selector-cell);
        min-width: calc(64% ~'-' @selector-cell);
        max-width: calc(64% ~'-' @selector-cell);
      }

      &:nth-child(4) {
        width: calc(18% ~'-' @selector-cell);
        min-width: calc(18% ~'-' @selector-cell);
        max-width: calc(18% ~'-' @selector-cell);
      }

      &.zero-state {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        justify-content: center;
      }
    }
  }

  &.five-columns {
    .header-cell,
    .body-cell {
      &:first-child {
        width: @selector-cell;
        min-width: @selector-cell;
        max-width: @selector-cell;
      }

      &:nth-child(2) {
        width: calc(18% ~'-' @selector-cell);
        min-width: calc(18% ~'-' @selector-cell);
        max-width: calc(18% ~'-' @selector-cell);
      }

      &:nth-child(3) {
        width: calc(18% ~'-' @selector-cell);
        min-width: calc(18% ~'-' @selector-cell);
        max-width: calc(18% ~'-' @selector-cell);
      }

      &:nth-child(4) {
        width: calc(42% ~'-' @selector-cell);
        min-width: calc(42% ~'-' @selector-cell);
        max-width: calc(42% ~'-' @selector-cell);
      }

      &:nth-child(5) {
        width: calc(22% ~'-' @selector-cell);
        min-width: calc(22% ~'-' @selector-cell);
        max-width: calc(22% ~'-' @selector-cell);
      }

      &.zero-state {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        justify-content: center;
      }
    }
  }
}

.header-row,
.body-row {
  display: flex;
  padding: 0 10px;
  justify-content: space-between;
  align-items: center;
}

.header-row {
  background: @label-batch-status--header-row--background-color;
  border-bottom: 1px solid @label-batch-status--row--border-color;
  min-height: 36px;
}

.body-row {
  background: @label-batch-status--body-row--background-color;
  min-height: 36px;
  &:not(:last-child) {
    border-bottom: 1px solid @label-batch-status--row--border-color;
  }
  &.selected {
    background-color: @label-batch-status--body-row--selected--background-color;
  }
}

.header-cell,
.body-cell {
  display: flex;
  align-items: center;

  line-height: 19px;

  &.expanded {
    height: 100%;
    line-height: 15px;
  }
}

.icon-wrap-container {
  display: flex;
  align-items: center;
  padding-right: 10px;
}

.icon-wrap {
  width: 14px;
  height: 14px;
  > svg {
    width: 100%;
    height: 100%;
    color: @label-batch-status--error--fill-color;
  }
  &.warning {
    > svg {
      color: @label-batch-status--warning--fill-color;
    }
  }
  &.error {
    > svg {
      color: @label-batch-status--error--fill-color;
    }
  }
}

.orderStatusIcon {
  width: 20px;
  height: 20px;

  padding: @space-4;
  color: var(--error--icon--fill-color--4);

  &.warning {
    color: var(--warning--icon--fill-color--2);
  }
}

.expandable-message {
  display: flex;
}

.error-warn-cell {
  display: flex;
  flex-flow: row wrap;
  height: auto;
}

.message-cell {
  display: flex;
  align-items: center;
  transition: all 500ms ease;
  padding: 5px 0;
  .message {
    flex: 1;
    max-width: 440px;
  }
  &.expanded {
    display: block;
  }
  &.truncated {
    .message {
      .truncate();
      line-height: normal;
    }
  }
  .expander {
    padding-left: 5px;
  }
}

.remove-button {
  padding-left: 35px;
  &:hover {
    cursor: pointer;
  }
}

.order-link {
  .truncate();
}
